




















































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import {
  POSProductCategory,
  POSProductCollectorData,
  POSProductType,
} from '@pos/interfaces/pos-v2';
import BpcInput from '@shared/components/forms/inputs/input/input.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import BpcPosContactForm from './pos-contact-form.vue';

interface ErrorObjectInterface {
  iban: string;
  bic: string;
}
export type errorsKeys = keyof ErrorObjectInterface;
export type errorObject = Partial<Record<errorsKeys, string[]>>;

@Component({
  name: 'bpc-pos-product-data-collector-modal',
  components: {
    BpcInput,
    'bpc-entity-select': EntitySelect,
    'bpc-pos-contact-form': BpcPosContactForm,
  },
})
export default class PosProductDataCollectorModal extends Vue {
  declare $refs: {
    contactSelect: InstanceType<typeof EntitySelect> & {
      getEntities(): void;
    };
  };
  @Prop({ type: String, default: '' }) readonly modalTitle: string;
  @Prop({ type: Number, default: 1 }) readonly defaultQuantity: number;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Boolean, default: false }) readonly addingProduct: boolean;
  @Prop({ type: Number }) readonly ticketId: number;
  @Prop({
    type: Number,
    required: true,
  })
  readonly posSessionId: number;
  @Prop({
    type: Number,
  })
  readonly defaultContactId: number;
  @Prop({
    type: Object,
  })
  readonly productCategory: POSProductCategory;
  @Prop({
    type: String,
  })
  readonly productType: POSProductType;
  // DATA
  closeDisabled: boolean = false;
  confirming: boolean = false;
  loading: boolean = false;
  quantity: number = this.defaultQuantity;
  sepaIban = '';
  sepaBic = '';
  badgeNumber = '';
  sepaContactId = null;
  printSepa = false;
  inputSelectContactSepaConfig = {
    fieldPath: 'contact',
    fieldReadPath: 'contact',
    name: 'contact',
    label: 'pos.sepa_contact_label',
    options: [],
    id: 'contact-sepa-id',
    rules: [],
    selectLabel: 'fullname',
    selectEntity: 'contact',
    selectMultiple: false,
    selectValue: 'id',
    withNew: false,
    disabled: true,
  };

  errorsObject: errorObject = {};
  passesValidation: boolean = true;

  // COMPUTED
  get isSepaActivated() {
    return !!this.$store.getters['centerSettings/centerSettings']?.activate_sepa_direct_debit;
  }

  get confirmDisabled(): boolean {
    switch (this.productType) {
      case 'subscription':
        return !this.sepaContactId;
      default:
        return false;
    }
  }

  // METHODS
  async getContactForSepa() {
    if (this.sepaContactId && this.isSepaActivated) {
      this.loading = true;
      const path = `${this.$bpcApiRouteHelper.getEntityPath('contacts')}/${this.sepaContactId}`;
      const queryConfig = {};
      const contact = await this.$bpcApi.get(path, queryConfig).toPromise();
      if (contact?.data) {
        this.sepaIban = contact.data.iban_number;
        this.sepaBic = contact.data.bic_number;
      }
      this.loading = false;
    }
  }

  async getContactForSepaIfStopChanging(contactId: number) {
    setTimeout(() => {
      if (contactId === this.sepaContactId && this.isSepaActivated) {
        this.getContactForSepa();
      }
    }, 300);
  }

  closeModal() {
    this.$emit('on-close');
  }

  async onConfirm() {
    this.confirming = true;
    this.passesValidation = true;
    const data: POSProductCollectorData = {
      productCategory: { ...this.productCategory },
      quantity: this.quantity,
      extraData: {},
    };
    switch (this.productType) {
      case 'subscription':
        data.extraData = {
          sepaContactId: this.sepaContactId,
          sepaIban: this.sepaIban,
          sepaBic: this.sepaBic,
          printSepa: this.printSepa,
          badgeNumber: this.badgeNumber,
          badgeType: 'rfid',
        };

        // Validate mandate
        try {
          const validationResponse = await this.$posService.validateSepaData(
            this.sepaIban,
            this.sepaBic,
          );
        } catch (error) {
          if (error?.response?.data?.errors) {
            this.manageErrors(error?.response?.data?.errors);
            this.passesValidation = false;
          }
        }
        break;
    }
    if (this.passesValidation) {
      this.$emit('on-data-collected', data);
    }
    this.confirming = false;
  }

  onChangeErrorObject(field) {
    delete this.errorsObject[field];
  }

  manageErrors(errors: any) {
    this.errorsObject = {};
    Object.keys(errors).forEach(key => {
      const aux = {
        error: errors[key][0],
        state: false,
      };
      this.$set(this.errorsObject, key, aux);
    });
  }

  // LIFECYCLE HOOKS
  mounted() {
    if (this.isSepaActivated && this.defaultContactId) {
      this.sepaContactId = this.defaultContactId;
    }
  }

  // WATCHERS
  @Watch('sepaContactId')
  onSepaContactIdChange(contactId) {
    if (contactId) {
      this.getContactForSepaIfStopChanging(contactId);
    }
  }
}
